export default __webpack_public_path__ + "static/media/restaurant.774f008a.jpg";